import React, { useState, useImperativeHandle, forwardRef, useRef } from "react";

import FloatLayout from "@/components/float-layout";
import styled from "styled-components";
import { saveAddrInfo, getAddrInfo } from '../api';
import select1 from "../imgs/select1@2x.png";
import select2 from "../imgs/select2@2x.png";
import Delivery from "./delivery";
import { Toast } from "antd-mobile";
const App = (props, ref) => {

  const [goodsName1, setGoodsName1] = useState('黑色款帆布包');
  const [goodsName2, setGoodsName2] = useState('红色保温杯');
  const [visible, setVisible] = useState(false);
  const [deliveryVisible, setDeliveryVisible] = useState(false);
  const deliveryRef = useRef('');

  useImperativeHandle(ref, () => {
    return {
      
      show: ()=> {
        setVisible(true);
      }
    }
  })

  // useEffect(()=> {
   
  // },[])

  const initAddr = () => {
    getAddrInfo({activityId: 135})
      .then(res => {
        if (res) {
          console.log(res);
          deliveryRef.current.setParams(res);
          // setAddrInfo(res)
        } else {
            const addrInfo = {
              recipientName: '',
              recipientPhone: '',
              recipientAddress: '',
              giftList: [goodsName1 ,goodsName2]
            }
          deliveryRef.current.setParams(addrInfo)
  
        }
      })
      .catch(err => {
        console.log(err);
      })
  }

  const selectGood = (type) => {
    if(type === 1) {
      setGoodsName1('黑色款帆布包')
    }else if(type === 2) {
      setGoodsName1('白色款帆布包')
    }else if(type === 3) {
      setGoodsName2('红色保温杯')
    }else if(type === 4) {
      setGoodsName2('白色咖啡杯')
    }
  }


  const handleSubmitAddr = (addr) => {
    
    const params = {
      activityId: 135,
      ...addr,
      giftList: [goodsName1 ,goodsName2]
    }

    saveAddrInfo(params)
    .then(res => {
      Toast.info('地址填写成功')
      setTimeout(()=> {
        onClose();
        setDeliveryVisible(false)
      }, 1500)
   
    })
    .catch(err => {
      // onClose();
      console.log(err);
    })
  }

  function onClose() {
    
    setVisible(false);
    props.onSubmit && props.onSubmit();
  }


  const handleSubmit = ()=> {
  
    setDeliveryVisible(true);


    initAddr();
  }


   return  <React.Fragment>
    <FloatLayout
      content={
        <LayoutWrap>
          <div className="delivery-title">支付成功 
            <img className="delivery-close" onClick={()=>{onClose()}} src={require('../imgs/close@2x.png')} alt=""/>
          </div>
          <div className="delivery-desc">会员与赠送会员天数已发放到账户</div>
          <div className="delivery-tip">周边免费赠，请分别选1款帆布包和1款杯子</div>

            <div className="wish-item">
              <div className= {goodsName1 === '黑色款帆布包'?"wish-goods select":"wish-goods"} onClick={()=> selectGood(1)}>
                <img src={require("../imgs/bao1.png")} alt=""/>
              </div>
              <div className= {goodsName1 === '白色款帆布包'?"wish-goods select":"wish-goods"}  onClick={()=> selectGood(2)}>
                <img src={require("../imgs/bao2.png")} alt=""/>
              </div>
            </div>
              <div className="name">帆布包（二选一）</div>
            <div className="wish-item">
              <div className= {goodsName2 === '红色保温杯'?"wish-goods select":"wish-goods"} onClick={()=> selectGood(3)}>
                <img src={require("../imgs/bei1.png")} alt=""/>
              </div>
              <div className= {goodsName2 === '白色咖啡杯'?"wish-goods select":"wish-goods"} onClick={()=> selectGood(4)}>
                <img src={require("../imgs/bei2.png")} alt=""/>
              </div>
            </div>
            <div  className="name">杯子（二选一）</div>
  
          <div onClick={handleSubmit} className="delivery-btn">确认并去填写收货地址</div>
        
        </LayoutWrap>
      }
      visible={visible}
      onOverlayClick={onClose}
    />
    {/* <Delivery /> */}
    <Delivery visible={deliveryVisible} ref={deliveryRef} onClose={() => setDeliveryVisible(false)} onSubmit={handleSubmitAddr} activityId={135} />
    </React.Fragment>
  //       , document.body
  // )
  // )
}

// export default App;
export default React.memo(forwardRef(App));

export const LayoutWrap = styled.div`
  position: relative;
  border-radius: 14px 14px 0px 0px;
  background-color: #fff;
  width: 100%;
  color: #3B3B3B;
  padding-top: 24px;
  padding-bottom: 21px;
  .delivery-close {
    position: absolute;
    top: 20px;
    right: 30px;
    width: 30px;
  }
  .delivery-title {
    font-size: 28px;
    font-weight: 500;
    line-height: 46px;
    text-align: center;
    margin-bottom: 15px;
  }
  
  .delivery-desc {
    margin-top: 6px;
    text-align: center;
    font-size: 16px;
    color: #4E4E4E;
    font-weight: 400;
    line-height: 14px;
  }
  .delivery-tip {
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    line-height: 14px;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 16px;
  }
  .delivery-btn {
    // width: 100%;
    height: 55px;
    font-size: 25px;
    background: linear-gradient(148deg, #FF3061, #FF9000);
    border-radius: 28px;
    margin: 22px 20px 0;
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
    line-height: 55px;
    text-align: center
  }

  .wish-item {
    display: flex;
    justify-content:space-between;
    padding: 0 20px;
    .wish-goods {
      width: 41.4vw;
      position: relative;
      &:after {
        content: '';
        width: 26px; 
        height: 26px;
        display: block;
        // background-color:red;
        position: absolute;
        background-image: url(${select1});
        background-repeat: no-repeat;
        background-size: contain;
        right: 10px;
        top: 10px;
      }
      &.select:after {
        background-image: url(${select2});
      }
      img {
        width: 100%;
      }
    }
  }
  .name {
    text-align: center;
    color: #2C2C2C;
    font-size: 15px;
    margin: 10px 0 24px;
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_135/components/PayResult.js